import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, vModelText as _vModelText, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "spin" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ion-margin-bottom" }
const _hoisted_10 = {
  key: 0,
  style: {"margin-bottom":"5px"}
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = { class: "ion-margin-top" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { class: "ion-margin-top" }
const _hoisted_23 = { class: "ion-margin-bottom" }
const _hoisted_24 = ["value", "onClick"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { class: "ion-margin-top" }
const _hoisted_31 = { class: "ion-margin-top" }
const _hoisted_32 = { class: "ion-margin-top" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { ref: "recaptchaDiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_logo_img = _resolveComponent("logo-img")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { style: {"background":"rgb(0, 80, 125)","box-shadow":"none"} }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--background":"transparent","--min-height":"100px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        style: {"color":"#fff"},
                        "router-link": "/"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            size: "large",
                            slot: "icon-only",
                            icon: $setup.arrowBack
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, {
                    slot: "end",
                    class: "ion-no-padding",
                    style: {"flex":"initial"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_logo_img, {
                        useWhiteLogo: true,
                        style: {"width":"180px"}
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ], 512), [
                [_vShow, $setup.loading]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                ($setup.featuredService && $setup.featuredService.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      ($setup.featuredService?.embeddedVideoSlideLink)
                        ? (_openBlock(), _createElementBlock("iframe", {
                            key: 0,
                            src: $setup.featuredService?.embeddedVideoSlideLink,
                            frameborder: "0",
                            style: {"width":"100%","height":"calc(min(100vw, 1000px) * 0.75)"},
                            allowfullscreen: "true",
                            mozallowfullscreen: "true",
                            webkitallowfullscreen: "true"
                          }, null, 8, _hoisted_3))
                        : ($setup.featuredService?.embeddedYTLink)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 1,
                              class: "responsive-embed",
                              style: {"width":"100%","height":"380px"},
                              src: $setup.featuredService?.embeddedYTLink,
                              frameborder: "0",
                              allowfullscreen: ""
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 2,
                              style: {"width":"100%"},
                              src: $setup.getProxyImgLink($setup.featuredService?.posterLink)
                            }, null, 8, _hoisted_5)),
                      ($setup.featuredService.description)
                        ? (_openBlock(), _createBlock(_component_ion_card, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                    innerHTML: $setup.getLinkifiedText($setup.featuredService?.description)
                                  }, null, 8, _hoisted_6),
                                  ($setup.prefilledServiceId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[48] || (_cache[48] = [
                                        _createElementVNode("br", null, null, -1),
                                        _createElementVNode("div", { style: {"white-space":"pre-line","color":"var(--ion-color-dark)"} }, " If you are interested in this program, please submit the below registration form, and we will follow up with you via WhatsApp. Thank you. ", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      style: {"margin-bottom":"10px"},
                      fill: "outline",
                      label: "You are a*",
                      "label-placement": "floating",
                      interface: "popover",
                      modelValue: $setup.application.roles,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.application.roles) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: "secondary-school-student" }, {
                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                            _createTextVNode("Secondary Student")
                          ])),
                          _: 1,
                          __: [49]
                        }),
                        _createVNode(_component_ion_select_option, { value: "teacher" }, {
                          default: _withCtx(() => _cache[50] || (_cache[50] = [
                            _createTextVNode("Secondary School Teacher / Principal")
                          ])),
                          _: 1,
                          __: [50]
                        }),
                        _createVNode(_component_ion_select_option, { value: "university-student" }, {
                          default: _withCtx(() => _cache[51] || (_cache[51] = [
                            _createTextVNode("University Student")
                          ])),
                          _: 1,
                          __: [51]
                        }),
                        _createVNode(_component_ion_select_option, { value: "university-client" }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createTextVNode("University Staff")
                          ])),
                          _: 1,
                          __: [52]
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    ($setup.isTeacher)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[53] || (_cache[53] = [
                          _createElementVNode("iframe", {
                            class: "slide-embed",
                            style: {"width":"100%","height":"560px"},
                            src: "https://docs.google.com/presentation/d/1EBxEhh9y_J7L_NzCIoItdvePsP4fQMUUVg-rT9EW9To/embed?start=true&loop=true&delayms=1000",
                            frameborder: "0",
                            allowfullscreen: "true",
                            mozallowfullscreen: "true",
                            webkitallowfullscreen: "true"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_ion_select, {
                        fill: "outline",
                        label: "What's your programme?*",
                        "label-placement": "stacked",
                        interface: "popover",
                        modelValue: $setup.application.programId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.application.programId) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobEXProgrammes, (programme) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: programme.name,
                              value: programme.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(programme.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 512), [
                      [_vShow, $setup.isUniversityStudent]
                    ])
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, !$setup.loading]
              ]),
              _withDirectives(_createElementVNode("form", {
                onSubmit: _cache[47] || (_cache[47] = _withModifiers(($event: any) => ($setup.doRegister()), ["prevent"])),
                style: {"padding-bottom":"150px"}
              }, [
                ($setup.featuredEvent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      ($setup.featuredEventService?.embeddedVideoSlideLink)
                        ? (_openBlock(), _createElementBlock("iframe", {
                            key: 0,
                            src: $setup.featuredEventService?.embeddedVideoSlideLink,
                            frameborder: "0",
                            style: {"width":"100%","height":"calc(min(100vw, 1000px) * 0.75)"},
                            allowfullscreen: "true",
                            mozallowfullscreen: "true",
                            webkitallowfullscreen: "true"
                          }, null, 8, _hoisted_11))
                        : ($setup.featuredEvent?.videoLink)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 1,
                              class: "responsive-embed",
                              style: {"width":"100%","height":"380px"},
                              src: $setup.featuredEvent?.videoLink,
                              frameborder: "0",
                              allowfullscreen: ""
                            }, null, 8, _hoisted_12))
                          : _createCommentVNode("", true),
                      ($setup.featuredEventService?.description)
                        ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
                            key: 2,
                            value: "details"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_accordion, { value: "details" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    style: {"--border-width":"0px !important"},
                                    slot: "header",
                                    color: "fdmtred"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => _cache[54] || (_cache[54] = [
                                          _createElementVNode("p", null, "All details (including school circular)", -1)
                                        ])),
                                        _: 1,
                                        __: [54]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card, {
                                    style: {"margin":"1.5px"},
                                    slot: "content"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          ($setup.featuredEventService?.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                _createElementVNode("div", {
                                                  style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                                  innerHTML: $setup.getLinkifiedText($setup.featuredEventService?.description)
                                                }, null, 8, _hoisted_14)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!$setup.isTeacher)
                  ? (_openBlock(), _createBlock(_component_section_header, {
                      key: 1,
                      title: "Personal Information"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    ($setup.isTeacher)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            label: $setup.t('school'),
                            "label-placement": "floating",
                            type: "text",
                            modelValue: $setup.application.schoolName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.application.schoolName) = $event)),
                            clearInput: true,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openSchoolSelectModal())),
                            required: ""
                          }, null, 8, ["label", "modelValue"]),
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            label: "Your position(s) in the school",
                            "label-placement": "floating",
                            type: "text",
                            modelValue: $setup.application.roleInSchool,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.application.roleInSchool) = $event)),
                            clearInput: true,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openRoleInSchoolSelectModal())),
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_textarea, {
                            fill: "outline",
                            label: "Your role(s) in class(es)",
                            "label-placement": "floating",
                            type: "text",
                            value: $setup.application.rolesInClasses.map(ric => `${ric.role} (${ric.classes})`).join('\n'),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openRolesInClassesModal()))
                          }, null, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_input, {
                      fill: "outline",
                      ref: "fullNameInput",
                      label: `${$setup.t('fullName')}*`,
                      "label-placement": "floating",
                      type: "text",
                      modelValue: $setup.application.fullName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.application.fullName) = $event)),
                      enterkeyhint: "next",
                      onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => ($setup.focusInputField($setup.preferredNameInput)), ["enter"])),
                      required: ""
                    }, null, 8, ["label", "modelValue"]),
                    (!$setup.prefilledServiceId)
                      ? (_openBlock(), _createBlock(_component_ion_input, {
                          key: 1,
                          fill: "outline",
                          ref: "preferredNameInput",
                          label: `${$setup.t('preferredName')}`,
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.preferredName,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.application.preferredName) = $event)),
                          enterkeyhint: "next",
                          onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => ($setup.focusInputField($setup.chineseNameInput)), ["enter"]))
                        }, null, 8, ["label", "modelValue"]))
                      : _createCommentVNode("", true),
                    ($setup.isSecondaryStudent)
                      ? (_openBlock(), _createBlock(_component_ion_input, {
                          key: 2,
                          fill: "outline",
                          ref: "chineseNameInput",
                          label: `${$setup.t('chineseName')}`,
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.chineseName,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.application.chineseName) = $event)),
                          enterkeyhint: "next"
                        }, null, 8, ["label", "modelValue"]))
                      : _createCommentVNode("", true),
                    (!$setup.prefilledServiceId)
                      ? (_openBlock(), _createBlock(_component_ion_select, {
                          key: 3,
                          fill: "outline",
                          label: "Gender*",
                          "label-placement": "floating",
                          interface: "popover",
                          modelValue: $setup.application.gender,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.application.gender) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: "male" }, {
                              default: _withCtx(() => _cache[55] || (_cache[55] = [
                                _createTextVNode("Male")
                              ])),
                              _: 1,
                              __: [55]
                            }),
                            _createVNode(_component_ion_select_option, { value: "female" }, {
                              default: _withCtx(() => _cache[56] || (_cache[56] = [
                                _createTextVNode("Female")
                              ])),
                              _: 1,
                              __: [56]
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_input, {
                      fill: "outline",
                      ref: "phoneInput",
                      label: `${$setup.t('phone')}*`,
                      "label-placement": "floating",
                      inputmode: "numeric",
                      modelValue: $setup.application.phone,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.application.phone) = $event)),
                      maxlength: "8",
                      onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => ($setup.focusInputField($setup.emailInput)), ["enter"])),
                      required: "",
                      "helper-text": "A HK mobile number is needed for accessing FDMT AchieveBot",
                      disabled: $setup.user?.id && $setup.application.phone?.toString().length == 8
                    }, null, 8, ["label", "modelValue", "disabled"]),
                    ($setup.isUniversityClient)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            ref: "emailInput",
                            label: "University email address*",
                            "label-placement": "floating",
                            inputmode: "email",
                            type: "email",
                            modelValue: $setup.application.uniEmail,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.application.uniEmail) = $event)),
                            enterkeyhint: "next",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            label: "University / Institution*",
                            "label-placement": "floating",
                            type: "text",
                            modelValue: $setup.application.institution,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.application.institution) = $event)),
                            enterkeyhint: "next",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ion_input, {
                            fill: "outline",
                            label: "Your position*",
                            "label-placement": "floating",
                            type: "text",
                            modelValue: $setup.application.position,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.application.position) = $event)),
                            enterkeyhint: "next",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : (!$setup.prefilledServiceId)
                        ? (_openBlock(), _createBlock(_component_ion_input, {
                            key: 5,
                            style: {"margin-bottom":"0"},
                            fill: "outline",
                            ref: "emailInput",
                            label: `${$setup.isUniversityStudent ? 'Gmail address' : $setup.t('schoolEmail')}*`,
                            "label-placement": "floating",
                            inputmode: "email",
                            type: "email",
                            modelValue: $setup.application.email,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.application.email) = $event)),
                            enterkeyhint: "next",
                            required: $setup.application.roles != 'teacher',
                            "helper-text": $setup.isUniversityStudent ? 'A gmail account is needed for CV resource sharing' : ''
                          }, null, 8, ["label", "modelValue", "required", "helper-text"]))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_17, [
                  ($setup.isSecondaryStudent || $setup.isUniversityStudent)
                    ? (_openBlock(), _createBlock(_component_section_header, {
                        key: 0,
                        title: "Study Information"
                      }))
                    : _createCommentVNode("", true)
                ]),
                ($setup.isSecondaryStudent)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          label: `${$setup.t('school')}*`,
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.schoolName,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.application.schoolName) = $event)),
                          clearInput: true,
                          onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.openSchoolSelectModal())),
                          required: ""
                        }, null, 8, ["label", "modelValue"]),
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          label: `${$setup.t('class')}*`,
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.class,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.application.class) = $event)),
                          enterkeyhint: "next",
                          autocapitalize: "characters",
                          placeholder: "e.g. 4C, 5A, 5F, 6L, etc.",
                          onKeyup: _cache[22] || (_cache[22] = _withKeys(($event: any) => ($setup.focusInputField($setup.studentNumberInput)), ["enter"])),
                          required: ""
                        }, null, 8, ["label", "modelValue"]),
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          ref: "studentNumberInput",
                          label: `${$setup.t('studentNumber')}*`,
                          "label-placement": "floating",
                          type: "number",
                          modelValue: $setup.application.studentNumber,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.application.studentNumber) = $event)),
                          enterkeyhint: "next",
                          placeholder: "班號/學號",
                          required: ""
                        }, null, 8, ["label", "modelValue"]),
                        (!$setup.user?.id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_ion_select, {
                                style: {"margin-bottom":"0"},
                                fill: "outline",
                                label: "What was your rank in your form on the last exam?*",
                                "label-placement": "floating",
                                interface: "popover",
                                modelValue: $setup.application.rankInForm,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.application.rankInForm) = $event)),
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.rankInForm, (rankRange) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: rankRange,
                                      value: rankRange
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(rankRange), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.application.rankInForm) = $event)),
                                required: "",
                                style: {"opacity":"0","height":"0.01px"}
                              }, null, 512), [
                                [_vModelText, $setup.application.rankInForm]
                              ]),
                              _createVNode(_component_ion_select, {
                                fill: "outline",
                                label: "Studying curriculum",
                                "label-placement": "floating",
                                interface: "popover",
                                modelValue: $setup.application.studyingCurriculum,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.application.studyingCurriculum) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.curriculums, (curriculum) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: curriculum,
                                      value: curriculum
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(curriculum), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_select, {
                                  style: {"margin-bottom":"0"},
                                  fill: "outline",
                                  label: "In which year will you graduate / take the HKDSE?*",
                                  "label-placement": "floating",
                                  interface: "popover",
                                  modelValue: $setup.application.yearDSE,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.application.yearDSE) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.yearDSE, (year) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: year,
                                        value: year
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(year) + " (" + _toDisplayString($setup.getSecStudentForm(year)) + ") ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.application.yearDSE) = $event)),
                                  required: "",
                                  style: {"opacity":"0","height":"0.1px"}
                                }, null, 512), [
                                  [_vModelText, $setup.application.yearDSE]
                                ])
                              ]),
                              ($setup.application.yearDSE && Number($setup.application.yearDSE) <= $setup.getF4YearDSE())
                                ? (_openBlock(), _createBlock(_component_ion_select, {
                                    key: 0,
                                    fill: "outline",
                                    label: "Which elective subject(s) are your studying?*",
                                    "label-placement": "floating",
                                    interface: "popover",
                                    modelValue: $setup.application.studyingElectives,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.application.studyingElectives) = $event)),
                                    multiple: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.application.studyingCurriculum == 'IGCSE' ? $setup.OPTIONS.electivesIGCSE : $setup.OPTIONS.electives, (elective) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: elective,
                                          value: elective
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(elective), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              ($setup.application.showReferrerInput)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_ion_input, {
                                      fill: "outline",
                                      label: "Referrer's name (if applicable)",
                                      "label-placement": "floating",
                                      modelValue: $setup.application.referrerName,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.application.referrerName) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.isUniversityStudent)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          ref: "uniEmailInput",
                          label: "University email address*",
                          "label-placement": "floating",
                          inputmode: "email",
                          type: "email",
                          modelValue: $setup.application.uniEmail,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.application.uniEmail) = $event)),
                          enterkeyhint: "next",
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          ref: "uniStudentIdInput",
                          label: "University student ID*",
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.studentId,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (($setup.application.studentId) = $event)),
                          enterkeyhint: "next",
                          required: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ion_select, {
                          fill: "outline",
                          label: "Your student status*",
                          "label-placement": "floating",
                          interface: "popover",
                          modelValue: $setup.application.studentStatus,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.application.studentStatus) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.studentStatus, (status) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: status,
                                value: status
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(status), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_select, {
                          fill: "outline",
                          label: "Current year of study*",
                          "label-placement": "floating",
                          interface: "popover",
                          modelValue: $setup.application.yearOfStudy,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.application.yearOfStudy) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.yearOfStudy, (year) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: year,
                                value: year
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(year), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        ($setup.selectedJobEX()['Student Groups'])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_ion_select, {
                                fill: "outline",
                                label: "Your studying stream*",
                                "label-placement": "floating",
                                interface: "popover",
                                modelValue: $setup.application.studyingStream,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.application.studyingStream) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedJobEX()['Student Groups'].split(' , '), (stream) => {
                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                      key: stream,
                                      value: stream
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(stream), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128)),
                                  _createVNode(_component_ion_select_option, { value: "N/A" }, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode(" N/A ")
                                    ])),
                                    _: 1,
                                    __: [57]
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_select, {
                          fill: "outline",
                          label: "Graduation year*",
                          "label-placement": "floating",
                          interface: "popover",
                          modelValue: $setup.application.gradYear,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.application.gradYear) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.gradYear, (year) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: year,
                                value: year
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(year), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_select, {
                          fill: "outline",
                          label: "How do you know jobEX?*",
                          "label-placement": "floating",
                          interface: "popover",
                          modelValue: $setup.application.howToKnow,
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.application.howToKnow) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OPTIONS.howToKnow, (channel) => {
                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: channel,
                                value: channel
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(channel), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ion_input, {
                          fill: "outline",
                          label: "Referrer's mobile number (if applicable)",
                          "label-placement": "floating",
                          type: "text",
                          modelValue: $setup.application.referrer,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.application.referrer) = $event)),
                          "helper-text": "Both you and your referrer will get 1 more week of FDMT Career Atlass access"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ($setup.routeStudentGroup == 'ucircle' && $setup.isSecondaryStudent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_section_header, { title: "For UCircle applicants only" })
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[58] || (_cache[58] = _createElementVNode("p", null, [
                          _createElementVNode("b", null, "Who's your nominator for UCircle?")
                        ], -1)),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Your teacher', 'Your UCircler classmate', 'Myself', 'I will not join UCircle.'], (opt) => {
                          return _createVNode(_component_ion_item, {
                            lines: "none",
                            key: opt
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                slot: "start",
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($setup.application.referrerRole) = $event)),
                                name: "referrerRole",
                                value: opt,
                                onClick: ($event: any) => ($setup.application.referrerRole = ($setup.application.referrerRole == opt ? '' : $setup.application.referrerRole))
                              }, null, 8, _hoisted_24), [
                                [_vModelRadio, $setup.application.referrerRole]
                              ]),
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", null, _toDisplayString(opt), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        }), 64))
                      ]),
                      ($setup.isUCircleApplicant())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            ($setup.application.referrerRole != 'Myself')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createVNode(_component_ion_input, {
                                    fill: "outline",
                                    label: "Referrer's name",
                                    "label-placement": "floating",
                                    modelValue: $setup.application.referrerName,
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($setup.application.referrerName) = $event)),
                                    required: ""
                                  }, null, 8, ["modelValue"]),
                                  ($setup.application.referrerRole.includes('UCircler'))
                                    ? (_openBlock(), _createBlock(_component_ion_input, {
                                        key: 0,
                                        fill: "outline",
                                        label: "Referrer's HK mobile number",
                                        "label-placement": "floating",
                                        modelValue: $setup.application.referrerPhone,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.application.referrerPhone) = $event)),
                                        "helper-text": "8 digits without space in between",
                                        inputmode: "numeric",
                                        maxlength: "8",
                                        required: ""
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_textarea, {
                              modelValue: $setup.application.q1Ans,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($setup.application.q1Ans) = $event)),
                              label: "Q1. What's your most significant public speaking experience or experience of speaking on video?",
                              "label-placement": "floating",
                              fill: "outline",
                              "auto-grow": true,
                              required: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_textarea, {
                              modelValue: $setup.application.q2Ans,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (($setup.application.q2Ans) = $event)),
                              label: "Q2. What's your most significant leadership experience to date?",
                              "label-placement": "floating",
                              fill: "outline",
                              "auto-grow": true,
                              required: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_textarea, {
                              modelValue: $setup.application.q3Ans,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (($setup.application.q3Ans) = $event)),
                              label: "Q3. What are your hobbies and interests?",
                              "label-placement": "floating",
                              fill: "outline",
                              "auto-grow": true
                            }, null, 8, ["modelValue"]),
                            _cache[59] || (_cache[59] = _createElementVNode("p", { class: "question" }, [
                              _createElementVNode("b", null, "Are you a prefect in your school?")
                            ], -1)),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Yes', 'No'], (opt) => {
                              return _createVNode(_component_ion_item, {
                                lines: "none",
                                key: opt
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    slot: "start",
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.application.isPrefect) = $event)),
                                    name: "isPrefect",
                                    value: opt == 'Yes' ? true : false
                                  }, null, 8, _hoisted_27), [
                                    [_vModelRadio, $setup.application.isPrefect]
                                  ]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(opt), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            }), 64)),
                            _cache[60] || (_cache[60] = _createElementVNode("p", { class: "question" }, [
                              _createElementVNode("b", null, "How did you become aware of UCircle?*")
                            ], -1)),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Teachers', 'Friends / Classmates', 'UCircle YouTube video', 'Others'], (opt) => {
                              return _createVNode(_component_ion_item, {
                                lines: "none",
                                key: opt
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    slot: "start",
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.application.howToKnow) = $event)),
                                    name: "howToKnowUC",
                                    value: opt,
                                    required: ""
                                  }, null, 8, _hoisted_28), [
                                    [_vModelRadio, $setup.application.howToKnow]
                                  ]),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(opt), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            }), 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.isUCircleApplicant())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_section_header, { title: "Enjoy privilege (you can do this later)" })
                      ]),
                      _cache[62] || (_cache[62] = _createElementVNode("div", { class: "ion-padding-horizontal" }, [
                        _createElementVNode("p", null, "You are now eligible to below exculsive events. Please enroll if you are interested.")
                      ], -1)),
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => _cache[61] || (_cache[61] = [
                                  _createElementVNode("h2", null, [
                                    _createElementVNode("b", null, "UCircle Events")
                                  ], -1)
                                ])),
                                _: 1,
                                __: [61]
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upcomingUCircleEvents, (ev) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              lines: "full",
                              key: ev.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_checkbox, {
                                  slot: "start",
                                  style: {"margin-inline-start":"8px"},
                                  "onUpdate:modelValue": ($event: any) => ($setup.onCheckWorkEvent($event, ev)),
                                  modelValue: $setup.selectedEvents.find(e => e.id == ev.id) != null,
                                  legacy: true
                                }, null, 8, ["onUpdate:modelValue", "modelValue"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString(ev.name), 1),
                                    _createElementVNode("p", null, _toDisplayString(ev.formattedDateTime), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_section_header, { title: "Choose Events" })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upcomingTeacherEvents, (ev) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      lines: "full",
                      key: ev.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_checkbox, {
                          slot: "start",
                          style: {"margin-inline-start":"8px"},
                          "onUpdate:modelValue": ($event: any) => ($setup.onCheckWorkEvent($event, ev)),
                          modelValue: $setup.selectedEvents.find(e => e.id == ev.id) != null
                        }, null, 8, ["onUpdate:modelValue", "modelValue"]),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(ev.name), 1),
                            _createElementVNode("p", null, _toDisplayString(ev.formattedDateTime) + " " + _toDisplayString(ev.venue ? `at ${ev.venue}`: ""), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ], 512), [
                  [_vShow, $setup.isTeacher && $setup.upcomingTeacherEvents.length > 0 && ($setup.isPrincipal || $setup.selectedEvents.length > 0)]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_section_header, { title: "Choose Events" })
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedJobEXIntakeEvents(), (ev) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                      lines: "full",
                      key: ev.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_checkbox, {
                          slot: "start",
                          style: {"margin-inline-start":"8px"},
                          "onUpdate:modelValue": ($event: any) => ($setup.onCheckWorkEvent($event, ev)),
                          modelValue: $setup.selectedEvents.find(e => e.id == ev.id) != null
                        }, null, 8, ["onUpdate:modelValue", "modelValue"]),
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _createTextVNode(_toDisplayString($setup.selectedJobEX()["jobEX Name"]) + ": ", 1),
                              _createElementVNode("b", null, _toDisplayString(ev.formattedDateTime) + " " + _toDisplayString(ev.mode), 1)
                            ]),
                            (ev.remainingSeats != '')
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_33, [
                                  _createElementVNode("b", null, _toDisplayString(Math.max(0, ev.remainingSeats)), 1),
                                  _createTextVNode(" seat" + _toDisplayString(ev.remainingSeats > 1 ? 's' : '') + " left", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)), [
                      [_vShow, ev.remainingSeats > 0 || ev.remainingSeats == '']
                    ])
                  }), 128))
                ], 512), [
                  [_vShow, $setup.isUniversityStudent && $setup.selectedJobEXIntakeEvents().length > 0]
                ]),
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_content, {
                      innerHTML: $setup.settings.regFormTnc
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  type: "submit",
                  shape: "round",
                  expand: "block",
                  disabled: $setup.registeringAccount
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.t('RegisterPage.register')) + " ", 1),
                    _createElementVNode("div", _hoisted_34, _cache[63] || (_cache[63] = [
                      _createElementVNode("div", { id: "grecaptcha-div" }, null, -1)
                    ]), 512)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 544), [
                [_vShow, !$setup.loading && $setup.application.roles && ($setup.isUniversityStudent ? $setup.application.programId : true)]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}